import React, { useState } from "react";
import DateRangeFilter from "reusable/datefilterrange";
import Export from "reusable/export";
import FailedInspection from "reusable/FailedInspection";
import SortBy from "reusable/sortby";
import { useTranslation } from 'react-i18next';

interface ToolbarProps {
  searchValue: string;
  sortValue: string;
  currentPage: number;
  onSearchChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onPageChange: (value: number) => void;
  onDateRangeChange: (startDate: string, endDate: string) => void;
  onFailedInspectionChange: (value: boolean | null) => void;
}

interface DataItem {
  id: number;
  name: string;
}

let data: DataItem[] = [];
data.push({ id: 1, name: "Item 1" });

const InspectionToolbar: React.FC<ToolbarProps> = ({
  sortValue,
  onSearchChange,
  onSortChange,
  onPageChange,
  onDateRangeChange,
  onFailedInspectionChange,
}) => {
  const { t, i18n } = useTranslation('common');
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });

  const sortingOptions = [
    { label: t('sort.default'), value: "" },
    { label: t('sort.plate-number'), value: "plate_number" },
  ];

  const handleSortChange = (value: string) => {
    onSortChange(value);
    onPageChange(1); 
  };

  const handleDateRangeChange = (startDate: string, endDate: string) => {
    setDateRange({ startDate, endDate });
    onDateRangeChange(startDate, endDate); 
  };

  const exportFields = [
    { header: 'Driver Name', field: 'user.name' },
    { header: 'Driver Phone', field: 'user.phone' },
    { header: 'Test Result', field: 'data' },
    { header: 'Date & Time', field: 'testing_time' }
  ];

  return (
    <section className="flex flex-row justify-between">
      <div className="flex w-1/4">
        <DateRangeFilter onDateRangeChange={handleDateRangeChange} position="right" />
      </div>
      <div className="flex flex-row justify-center items-center space-x-2">
        <SortBy
          options={sortingOptions}
          defaultValue={sortValue}
          onChange={handleSortChange}
        />
        <FailedInspection onChange={onFailedInspectionChange} />
        <Export
          data={data}
          exportFields={exportFields}
        />
      </div>
    </section>
  );
}

export default InspectionToolbar;